import React from "react";
import "../../assets/css/sidebar.css";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  RiNotificationBadgeFill,
  RiShieldUserFill,
  RiShoppingCartFill,
} from "react-icons/ri";
import { BsFillCalendarEventFill } from "react-icons/bs";
import { FaPowerOff } from "react-icons/fa";
import { MdDeliveryDining } from "react-icons/md";
import Profile from "../../assets/img/logos.png";

export default function Sidebar() {
  const current = new Date();
  const currentDate = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;

  return (
    <>
      <Col lg={2} className="sidebar p-3 bg-light shadow d-none d-lg-block">
        <Col className="d-flex justify-content-start align-items-center">
          <img
            src={Profile}
            alt="jannu's Food profile"
            height="auto"
            width="40%"
            className="me-2"
          />
          <Col>
            <Link to="/landing" className="text-decoration-none text-dark">
              <span>Jannu's health Food</span>
            </Link>
            <br />
            <span className="text-secondary">
              <small>{currentDate}</small>
            </span>
          </Col>
        </Col>
        <Col className="sidebarMenu mt-3">
          <ul>
            <li>
              <Link to="/notification">
                <RiNotificationBadgeFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Notifications
              </Link>
            </li>
            <li>
              <Link to="/userDetails">
                <RiShieldUserFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Managing Users
              </Link>
            </li>
            <li>
              <Link to="/productDetails">
                <RiShoppingCartFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Product List
              </Link>
            </li>
            <li>
              <Link to="/productOfMonth">
                <BsFillCalendarEventFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Product Of The Month
              </Link>
            </li>
            <li>
              <Link to="/courier">
                <MdDeliveryDining
                  className="text-dark me-2"
                  style={{ fontSize: "1.2em" }}
                />
                Courier
              </Link>
            </li>
            <li>
              <Link to="/">
                <FaPowerOff
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Logout
              </Link>
            </li>
          </ul>
        </Col>
      </Col>
    </>
  );
}
